var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styles from './Chips.module.scss';
import { v4 as uuid } from 'uuid';
import { Chip } from './components';
var Chips = function (_a) {
    var options = _a.options, removeable = _a.removeable, bordered = _a.bordered, limit = _a.limit, primary = _a.primary, danger = _a.danger, warning = _a.warning, className = _a.className, id = _a.id, dataId = _a.dataId, onChange = _a.onChange;
    var onChipRemove = function (value) {
        var filtered = options.filter(function (o) { return o.value !== value; });
        onChange === null || onChange === void 0 ? void 0 : onChange(filtered);
    };
    var getOptionsWithLimit = function (limit) {
        var renderOpts = __spreadArray([], options, true).splice(0, limit);
        var other = options.length - limit;
        other > 0 && renderOpts.push({ label: "+".concat(other), value: '' });
        return renderOpts;
    };
    var getOptions = function () {
        return limit ? getOptionsWithLimit(limit) : options;
    };
    var renderChips = function () {
        return getOptions().map(function (o) { return (_jsx(Chip, { label: o.label, value: o.value, bordered: bordered, primary: primary, danger: danger, warning: warning, removeable: !!o.value && removeable, onRemove: function () { return !!o.value && onChipRemove(o.value); } }, uuid())); });
    };
    return (_jsx("ul", __assign({ className: "".concat(styles.Chips, " ").concat(className ? className : ''), id: id, "data-testid": dataId }, { children: options && renderChips() })));
};
Chips.propTypes = {
    options: PropTypes.arrayOf(PropTypes.any).isRequired,
    removeable: PropTypes.bool,
    bordered: PropTypes.bool,
    limit: PropTypes.number,
    primary: PropTypes.bool,
    danger: PropTypes.bool,
    warning: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
    dataId: PropTypes.string,
    onChange: PropTypes.func,
};
Chips.defaultProps = {
    className: '',
};
export { Chips };
//# sourceMappingURL=Chips.js.map